import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Masonry from '@mui/lab/Masonry';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { styled }, "@mui/icons-material/ExpandMore": ExpandMoreIcon, "@mui/lab/Masonry": Masonry, "@mui/material/Accordion": Accordion, "@mui/material/AccordionDetails": AccordionDetails, "@mui/material/AccordionSummary": AccordionSummary, "@mui/material/Typography": Typography, "@mui/material/Box": Box, "@mui/material/Paper": Paper } } });
export default ClientProvider;
